import React from 'react';
import {AuthorizationsWrapper} from 'presentation/pages';

export const MakeAuthorizations: React.FC = () => <AuthorizationsWrapper />;
